export type CareflowSyncReason =
  | "chart_event_saved"
  | "chart_event_deleted"
  | "history_created"
  | "history_deleted"
  | "tags_saved"
  | "collab_created"
  | "collab_deleted"
  | "manual_refresh"
  | "patient_archived"
  | "patient_updated"
  | "appointment_created";

export interface CareflowSyncPayload {
  reason: CareflowSyncReason;
  visitId?: number | null;
  patientId?: string | null;
  at: number;
}

const EVENT_NAME = "careflow:sync";
const STORAGE_KEY = "careflow:sync:last";

export function emitCareflowSync(input: Omit<CareflowSyncPayload, "at">): void {
  const payload: CareflowSyncPayload = {
    ...input,
    at: Date.now(),
  };
  try {
    window.dispatchEvent(new CustomEvent<CareflowSyncPayload>(EVENT_NAME, { detail: payload }));
  } catch {
    // no-op
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // no-op
  }
}

export function subscribeCareflowSync(
  cb: (_payload: CareflowSyncPayload) => void
): () => void {
  const onCustom = (event: Event) => {
    const ce = event as CustomEvent<CareflowSyncPayload>;
    if (ce?.detail) cb(ce.detail);
  };
  const onStorage = (event: StorageEvent) => {
    if (event.key !== STORAGE_KEY || !event.newValue) return;
    try {
      const parsed = JSON.parse(event.newValue) as CareflowSyncPayload;
      if (parsed && typeof parsed === "object") cb(parsed);
    } catch {
      // no-op
    }
  };
  window.addEventListener(EVENT_NAME, onCustom as EventListener);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(EVENT_NAME, onCustom as EventListener);
    window.removeEventListener("storage", onStorage);
  };
}
